export const KEYCODES = {
  ENTER: 13,
  FWD_SLASH: 47,
  BACK_SLASH: 46,
  ESC: 27,
  TAB_KEY: 9,
};
export default KEYCODES;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/common/keyCodes.js